import '@/styles/global.css';

import * as Sentry from '@sentry/react';
import { NuqsAdapter } from 'nuqs/adapters/react';

import { SPALayout } from '@crehana/layouts/spa/layout-with-centralized';

import { AddBaseFunctionality } from '@/shared/components/add-base-functionality';
import { Outlet, useParams } from '@/shared/modern-router';
import { useIsRenderedFromWebView } from '@crehana/react-hooks/use-is-rendered-from-webview';

import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';

const App = () => {
  const { slug, orgSlug } = useParams();
  const isWebView = useIsRenderedFromWebView();

  return (
    <div className="tw-isolate">
      <SPALayout
        sentryInstance={Sentry}
        organizationSlug={(slug || orgSlug) as string}
        intercomConfig={{
          enabled: !isWebView,
        }}
      >
        <NuqsAdapter>
          <Outlet />
          <HanaFloatingChatLazy />
        </NuqsAdapter>
        <AddBaseFunctionality />
      </SPALayout>
    </div>
  );
};

export default App;
